module.exports = __webpack_public_path__ + "static/media/web-portfolio.66a87ab3.jpg";